export class MissingTcUuidError extends Error {
  constructor(oppId: string) {
    super(`[TermsAndConditions] oppId: ${oppId} does not have tcUuid`);
  }
}
